import React from 'react';
import Icon from '../AppIcon';

function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  isLoading = false,
  disabled = false,
  className = '',
  onClick,
  type = 'button',
  ...props
}) {
  const baseClasses = 'btn inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';

  const variantClasses = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800',
    secondary: 'bg-white text-slate-900 border border-slate-200 hover:bg-slate-50 active:bg-slate-100',
    outline: 'border border-primary-600 text-primary-600 bg-transparent hover:bg-primary-50 active:bg-primary-100',
    ghost: 'text-slate-600 hover:bg-slate-100 active:bg-slate-200',
    link: 'text-primary-600 underline-offset-4 hover:underline p-0 h-auto',
    icon: 'p-2 text-slate-600 hover:bg-slate-100 active:bg-slate-200 rounded-full',
  };

  const sizeClasses = {
    sm: 'text-xs 3xl:text-sm 4xl:text-base px-3 py-2 3xl:px-4 3xl:py-2.5 rounded-lg',
    md: 'text-sm 3xl:text-base 4xl:text-lg px-5 py-2.5 3xl:px-6 3xl:py-3 rounded-lg',
    lg: 'text-base 3xl:text-lg 4xl:text-xl px-6 py-3 3xl:px-8 3xl:py-4 rounded-xl',
    xl: 'text-lg 3xl:text-xl 4xl:text-2xl px-8 py-4 3xl:px-10 3xl:py-5 rounded-xl',
  };

  // Icon-only button gets special sizing
  const iconSizeClasses = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-2.5',
    xl: 'p-3',
  };

  const buttonClasses = [
    baseClasses,
    variant === 'icon' ? '' : sizeClasses[size],
    variant === 'icon' ? iconSizeClasses[size] : '',
    variantClasses[variant],
    className
  ].join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
    >
      {isLoading && (
        <span className="mr-2">
          <Icon
            name="Loader2"
            className="animate-spin"
            size={size === 'sm' ? 14 : size === 'lg' ? 20 : size === 'xl' ? 24 : 16}
          />
        </span>
      )}

      {icon && iconPosition === 'left' && !isLoading && (
        <Icon
          name={icon}
          className="mr-2"
          size={size === 'sm' ? 14 : size === 'lg' ? 20 : size === 'xl' ? 24 : 16}
        />
      )}

      {variant === 'icon' ? (
        <Icon
          name={icon || 'Plus'}
          size={size === 'sm' ? 14 : size === 'lg' ? 20 : size === 'xl' ? 24 : 16}
        />
      ) : (
        children
      )}

      {icon && iconPosition === 'right' && !isLoading && (
        <Icon
          name={icon}
          className="ml-2"
          size={size === 'sm' ? 14 : size === 'lg' ? 20 : size === 'xl' ? 24 : 16}
        />
      )}
    </button>
  );
}

export default Button;